import { Component } from '@angular/core';
import { MasterRegionsComponent } from './master-regions/master-regions.component';
import { MasterCountriesComponent } from './master-countries/master-countries.component';
import { MasterCitiesComponent } from './master-cities/master-cities.component';
import { MasterStoresComponent } from './master-stores/master-stores.component';

@Component({
  selector: 'app-masterdata-locations',
  standalone: true,
  imports: [MasterRegionsComponent, MasterCountriesComponent, MasterCitiesComponent, MasterStoresComponent],
  templateUrl: './masterdata-locations.component.html',
  styleUrls: ['./masterdata-locations.component.scss', '../../app.component.scss']
})
export class MasterdataLocationsComponent {

}
